module.exports = __webpack_public_path__ + "static/media/icon_dataset_round.c72b0664.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/icon_dataset_round.svg
// module id = 353
// module chunks = 0